import { emptyV2Api as api } from "../../emptyV2Api";
// import { InventoryUploadJob } from "../../inventory/InventoryUploadJob";
import { UsimInventoryItem, UsimInventoryResponse, UsimStockResponse } from "./inventoryItem";
import { UsimInventoryUploadJob } from "./usimInventoryUploadJobs";


const SLUG = "/usim/inventory"
const injectedApi = api
  .enhanceEndpoints({ addTagTypes: ["inventory"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsimInventory: build.query<UsimInventoryResponse, {
        type?: string;
        mobileNumber?: string;
        iccid?: string;
        limit?: number;
      }>({
        query: (params = { limit: 300 }) => {
          const searchParams = new URLSearchParams();
          if (params.limit) searchParams.append("limit", params.limit.toString());
          if (params.type) searchParams.append("type", params.type);
          if (params.mobileNumber) searchParams.append("mobileNumber", params.mobileNumber);
          if (params.iccid) searchParams.append("iccid", params.iccid);
          return `${SLUG}/manage?${searchParams.toString()}`;
        },
        providesTags: ["inventory"]
      }),
      getUsimStock: build.query<UsimStockResponse, {
        sort_qty?: 'high' | 'low';
        sort_type?: 'asc' | 'desc';
        sort_plan?: 'asc' | 'desc';
      }>({
        query: (params) => {
          const searchParams = new URLSearchParams();
          searchParams.append("action", "stock");
          if (params?.sort_qty) searchParams.append("sort_qty", params.sort_qty);
          if (params?.sort_type) searchParams.append("sort_type", params.sort_type);
          if (params?.sort_plan) searchParams.append("sort_plan", params.sort_plan);
          return `/usim/product-plans/manage?type=stock&${searchParams.toString()}`;
        },
        providesTags: ["inventory"]
      }),
      getUsimInventoryItemByIccid: build.query<UsimInventoryItem, string>({
        query: (iccid) => SLUG + "/manage?iccid=" + iccid,
        providesTags: ["inventory"]
      }),
      getUsimInventoryUploadJobs: build.query<UsimInventoryUploadJob[], void>({
        query: () => SLUG + "/upload",
        providesTags: ["inventory"]
      }),
      postInventoryItem: build.mutation<UsimInventoryItem, UsimInventoryItem>({
        query: (item) => ({
          url: SLUG + "/manage",
          method: "POST",
          body: item
        }),
        invalidatesTags: ["inventory"]
      }),
      putInventoryItem: build.mutation<UsimInventoryItem, any>({
        query: (item) => ({
          url: SLUG + "/manage",
          method: "PUT",
          body: item
        }),
        invalidatesTags: ["inventory"]
      }),
      putInventoryItemStatus: build.mutation<UsimInventoryItem, UsimInventoryItem>({
        query: (item) => ({
          url: SLUG + "/manage?action=status",
          method: "PUT",
          body: item
        }),
        invalidatesTags: ["inventory"]
      }),
    })
});

export const {
  useGetUsimInventoryQuery,
  useGetUsimStockQuery,
  useGetUsimInventoryItemByIccidQuery,
  useGetUsimInventoryUploadJobsQuery,
  usePutInventoryItemMutation,
  usePutInventoryItemStatusMutation,
  usePostInventoryItemMutation

} = injectedApi;